(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("finalizePayPalExpressCheckout", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/storefront/paymentMethod/finalizePayPalExpressCheckoutView.html",
            controller: ["tenantPaymentMethodResource", "$state", FinalizePayPalExpressCheckoutCtrl],
            controllerAs: "vm"
        };
        function FinalizePayPalExpressCheckoutCtrl(tenantPaymentMethodResource, $state) {
            if ($state.params["request_token"] && $state.params["verification_code"]) {
                var data = {
                    requestToken: $state.params["request_token"],
                    verificationCode: $state.params["verification_code"]
                };
                tenantPaymentMethodResource.finalizePayPalExpressCheckout(data, function () {
                    $state.go("main.settings.storefront");
                }, function (error) {
                    console.error(error);
                });
            }
            else {
                $state.go("main.settings.storefront");
            }
        }
    });
}());
